import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { CareElementGridHelper } from "@/Flowsheets/Helpers/CareElementGridHelper";
import { CareElementOperatorType } from "@/Flowsheets/Models/CareElementOperatorType";
import { VitalSignCareElement } from "@/Flowsheets/Models/CareElements/VitalSignCareElement";
import { VitalSignCareElementName } from "@/Flowsheets/Models/CareElements/VitalSignCareElementName";

interface VitalSignGridTargetLabelProps {
    data: VitalSignCareElement;
}

function VitalSignGridTargetLabel({ data }: Readonly<VitalSignGridTargetLabelProps>): JSX.Element {
    const { getText } = useTranslation();
    const operatorValue = CareElementGridHelper.mapOperator(data.Operator, getText);

    if (data.Name === VitalSignCareElementName.BloodPressure && data.TargetRange?.LowerBound !== undefined && data.TargetRange?.UpperBound !== undefined) {
        return <p>{`${operatorValue} ${data.TargetRange.LowerBound}/${data.TargetRange.UpperBound}`}</p>;
    }

    if (data.Operator === CareElementOperatorType.Between && data.TargetRange?.LowerBound && data.TargetRange?.UpperBound) {
        return <p>{`${data.TargetRange.LowerBound} - ${data.TargetRange.UpperBound}`}</p>;
    }

    if (data.TargetRange?.LowerBound) {
        return <p>{`${operatorValue} ${data.TargetRange.LowerBound}`.trim()}</p>;
    }

    return <p />;
}

export default VitalSignGridTargetLabel;
